const ZERO_WIDTH_SPACE = '&#8203;'

export default function renderPre(content) {
  const line = (content === '') ? ZERO_WIDTH_SPACE : content
  return `<pre class="line" role="presentation">${line}</pre>`
}
